import { createContext, createElement } from 'react'

import { usePrivateAppUIModal } from './hooks/ui-modal'


import { useConfig } from '@/contexts/SiteContext/hooks';
import { useContext } from 'react';
const Context = createContext<ReturnType<typeof usePrivateAppUIModal>>(null!)

const ProviderComponent = ({ children }: { children: React.ReactNode }) => {
  const value = usePrivateAppUIModal()
  return createElement(Context.Provider, { value }, children)
}

export function AppUIModalProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const config = useConfig()
  if (!config.sessionProviderEnabled) {
    return <>{children}</>
  }

  return <ProviderComponent>{children}</ProviderComponent>
}

export function useAppUIModal() {
  const value = useContext(Context)
  return value
}
